import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { ApiFilterRequest } from 'src/app/shared/shared-interfaces';
import { Job } from '../../ss-sched/openapi';
import { SchedJobsService } from '../../ss-sched/services/jobs.service';
import { SchedTasksService } from '../../ss-sched/services/tasks.service';
import {
  JobGridListDtl,
  JobGridListDtlParameter,
  JobGridListResponse,
  ParamDef,
  ParamType
} from '../interfaces/job-grid-list';

@Injectable({
  providedIn: 'root'
})
export class SchedulerService {
  constructor(
    private jobsService: SchedJobsService,
    private tasksService: SchedTasksService
  ) {}

  public getJobs(pageSize?: number, restartRowId?: number, filter: ApiFilterRequest[] = [],
                 viewAll: boolean = true): Observable<JobGridListResponse> {
    const filterStr = filter?.length > 0 ? JSON.stringify(filter) : '[]';
    const view = viewAll ? 'JOB' : null;
    return this.jobsService.getListOfJobs(view, pageSize, restartRowId, filterStr, 'response')
      .pipe(map(resp => {
        return {
          restartRowNum: resp.headers.get('Restart-Row-Id'),
          items: resp.body.map(job => {
            return {
              jobId: job.jobId,
              jobType: _.startCase(job.taskType.toLowerCase()),
              jobDesc: job.jobDesc,
              requestedBy: job.createdBy,
              dateTime: job.createdTS,
              status: job.execStatus,
              taskName: job.taskName
            };
          })
        };
      }));
  }


  public getJobDetailsById(jobId: string): Observable<JobGridListDtl> {
    return this.jobsService.getJobByID(jobId).pipe(
      concatMap((job: Job) => {
        return this.tasksService.getTaskByName(job.taskName).pipe(map(result => {

          const taskParams: Map<string, ParamDef> = new Map<string, ParamDef>();
          result.taskParams?.forEach(param => {
            taskParams[param.key] = { desc: param.desc, type: param.type};
          });
          const taskResults: Map<string, ParamDef>  = new Map<string, ParamDef>();
          result.taskResults?.forEach(param => {
            taskResults[param.key] = { desc: param.desc, type: param.type};
          });
          return { job, taskParams,  taskResults};
        }));
      }),
      map((result: {job: Job, taskParams: Map<string, ParamDef>, taskResults: Map<string, ParamDef>}) => {
        return {
          inputParams: this.mapParams(result.job.jobParams, result.taskParams),
          outputParams: this.mapParams(result.job.execResults, result.taskResults),
          errors: result.job.execStatus === 'failed' ? this.mapErrors(result.job.execResults['error']) : []
        };
      })
    );
  }

  private mapParams(params: object, paramDefs: Map<string, ParamDef>): JobGridListDtlParameter[] {
    const mapped: JobGridListDtlParameter[] = [];
    for (const paramName in params) {
      mapped.push({
        name: this.getName(paramName, paramDefs),
        type: this.getType(paramName, paramDefs),
        value: params[paramName]
      });
    }
    return mapped;
  }

  private mapErrors(errors: any): string[] {
    if (typeof(errors) === 'string') {
      if (errors.includes('Message:')) {
        return [errors.substring(errors.indexOf('Message:') + 8, errors.indexOf('}') - 1)];
      }
      return [errors];
    }
    return [errors.errstatus.message];
  }

  private getName(paramName: string, params: Map<string, ParamDef>): string {
    const paramDef = params[paramName];
    if (paramDef == null) {
      return paramName;
    }
    return paramDef.desc;
  }

  private getType(paramName: string, params: Map<string, ParamDef>): string {
    const paramDef = params[paramName];
    if (paramDef == null) {
      return '';
    }
    return paramDef.type;
  }
}
